var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"light":true}},[_c('base-assignment',{attrs:{"available":_vm.available,"selected":_vm.selected},on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }